import {getSkpClassCodes, QuoteForm, SkpClass} from "api/quote";
import {useMemo} from "react";
import Field from "../../Field";
import Box from "components/Box";
import {useApiQuery} from "hooks/api";

interface SkpClassFormProps {
  skp_class: SkpClass;
  quoteForm: QuoteForm;
  selectedClassCodes: string[];
}

function SkpClassForm({
  skp_class,
  quoteForm,
  selectedClassCodes,
}: SkpClassFormProps) {
  const classCodesQuery = useApiQuery(getSkpClassCodes)();
  const classCodes = classCodesQuery.data;

  const companyNumber = quoteForm.company_number;
  const state = quoteForm.locations[0].state;

  const filteredOptions = useMemo(() => {
    if (!classCodes) return [];

    return classCodes
      .filter((item) => {
        const companyKey = companyNumber.toString();
        return (
          item.companies[companyKey] &&
          item.companies[companyKey].includes(state) &&
          !selectedClassCodes.includes(item.value)
        );
      })
      .map((item) => ({
        title: item.label,
        value: item.value,
      }));
  }, [classCodes, companyNumber, state, selectedClassCodes]);

  return (
    <Box mt={-12}>
      <Field.DropDown
        object={skp_class}
        options={filteredOptions}
        field={"class_code"}
        label="Select Class"
        wrapperProps={{
          grow: 12,
        }}
      />
    </Box>
  );
}

export default SkpClassForm;
